export type Subset<K> = {
  [attr in keyof K]?: K[attr] extends object ? Subset<K[attr]> : K[attr]
}

export function isEnumMember<E>(
  value: unknown,
  enumArg: Record<string | number | symbol, E>,
): value is E {
  return (Object.values(enumArg) as unknown[]).includes(value)
}

export interface SelectOption {
  value: string | number
  label: string
  disabled?: boolean
  hidden?: boolean
}

export interface SelectGroup {
  values: Array<string | number>
  label: string
  id: string | number
}

export interface RadioButtonItem {
  value: string | number
  label: string
  disabled?: boolean
}
